import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import main_logo from '../assets/images/UPG_site_logo.png';
import { Profile, getSetting } from '../API/admin'
import Loader from '../views/admin/Common/Loader'
import Footer from "../components/Footer"

// CSS 
import "../../src/assets/Contact.css";
import { useSnackbar } from 'notistack';
import Swal from "sweetalert2";
import { DropdownButton, Dropdown, Table, Row, Col, Card } from 'react-bootstrap';
import { contactEmail, FilterDynamicText } from '../API/admin'
import { PhotoAPI } from '../API/player';

function Contact() {

    const [dynamicHeading, setDynamicHeading] = useState({});
    const [loginUser, setLoginUser] = useState(null)
    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
    let [loaderStatus, setloaderStatus] = useState(true)

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });
    const [TournamentOff, setTouramentOff] = useState(false);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        let callAPI = async () => {
            let res = await getSetting()

            if (res.status) {
                res.data.map((entry, index) => {
                    if (entry.value == 'false' && entry.name === 'tournament_register') {
                        setTouramentOff(true);
                    }
                })
            } else {
                // setIsOn(null);
                enqueueSnackbar('unable to fetch setting', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })
            }
        }
        callAPI()
    }, [])
    useEffect(() => {
        let callAPIProfile = async () => {
            let res = await Profile()
            console.log(res)
            if (res.statusCode == 403) {
                setLoginUser(null)
                setloaderStatus(false)
            } else {
                setLoginUser(res.data)
                setloaderStatus(false)
            }
        }

        callAPIProfile()
    }, [])
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let res = await contactEmail(formData);
        if (res.status) {
            enqueueSnackbar("Contact request sent successfully", {
                variant: 'success', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                message: ''
            })
        } else {
            enqueueSnackbar("Unable to send contact request", {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });

        }
    };

    //  Photo/Video Request hit 
    useEffect(() => {

        let callAPIDynamictext = async () => {
            let formData = {
                "data": null
            }
            let res = await FilterDynamicText(formData);
            if (res.data.status) {
                console.log(res.data.data)
                setDynamicHeading(res.data.data)
            }
        }
        callAPIDynamictext();
    }, [])

    let PhotoReq = async () => {
        console.log("Hello")
        Swal.fire({
            title: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.title
                : "Request photo/video?",
            text: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.value : "Request photo/video?",
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request",
            cancelButtonText: "Close"

        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await PhotoAPI();
                if (res.data.status) {
                    if (res.data.NoMatch) {
                        enqueueSnackbar('You have not played any matches yet', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    } else {

                        enqueueSnackbar('Request was sent successfully', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    }
                } else {
                    enqueueSnackbar('Unable to send request at the moment', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    })
                }

            }
        });

    }


    //    My profile navigation
    let Myprofilenavigate;
    if (loginUser) {
        switch (loginUser.role) {
            case "participant":
                Myprofilenavigate = "/participant/profile";
                break;
            case "admin":
                Myprofilenavigate = "/admin/profile";
                break;
            case "scorer":
                Myprofilenavigate = "/scorer/profile";
                break;
            default:
                Myprofilenavigate = "/";
                break;
        }
    } else {
        Myprofilenavigate = "/"; // Redirect to login if user is not logged in
    }



    return (
        <>
            {loaderStatus ? <Loader /> : null}

            <div className="main_div_heigtport">
                <header>
                    <nav className="navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage">
                        <a className="navbar-brand" href="/">
                            <img src={main_logo} alt="Logo" />
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            style={{ background: '#B2022F' }}
                        >
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="bi bi-list" style={{ color: "#fff", fontSize: "25px" }}></i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto nav-list">
                                {
                                    loginUser != null ? (
                                        <>
                                          <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                            <li className='nav-item'
                                                style={{ display: (loginUser != null) ? "block" : "none" }} >
                                                <NavLink className='nav_page_btn mobile_displa_dashboard' to='/dashboard' activeClassName='active'>
                                                    Dashboard
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <img
                                                        src={loginUser.profile_image !== undefined ?
                                                            IMAGE_URL + "user/" + loginUser.profile_image : IMAGE_URL + "blank_user.png"}
                                                        alt="Profile"
                                                        className="rounded-circle"
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end new_header_dropdown" aria-labelledby="navbarDropdown">
                                                    <li className='mobile_displa_popup_dashboard'>
                                                        <NavLink className="dropdown-item" to="/dashboard">Dashboard</NavLink>
                                                    </li>
                                                    <li>
                                                        {/* Changed to NavLink */}
                                                        <NavLink className="dropdown-item" to={Myprofilenavigate}>My Profile</NavLink>
                                                    </li>
                                                    <li style={{ display: (loginUser.role === "participant") ? "block" : "none" }}
                                                        onClick={() => PhotoReq()}>
                                                        {/* Changed to NavLink */}
                                                        <Link className="dropdown-item"> Request Photo/Video</Link>
                                                    </li>
                                                    <li>
                                                        {/* Changed to NavLink */}
                                                        <Link className="dropdown-item" to="/logout">Logout</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </>
                                    ) : (
                                        <>
                                        <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                           
                                            <li className="nav-item">
                                                <NavLink className="signup_btn" to="/register" activeClassName='active'>
                                                    Register Now
                                                </NavLink>
                                            </li>
                                                   
                                            <li className="nav-item">
                                                <NavLink className="login_btn" to="/login" activeClassName='active'>
                                                    Login
                                                </NavLink>
                                            </li>
                                        </>
                                    )
                                }
                            </ul>
                        </div>
                    </nav>
                </header>
                <section className='headre_bg_div'></section>
                <div className='container-fluid flex-grow-1' style={{ background: "#000" }}>
                    <div className='container-lg main-container text-white'>
                        <Row className='pt-4'> <h3 className='all_new_pages_heading' >GET IN TOUCH </h3></Row>
                        <section className='contact_form_sec'>
                            <div className='row'>
                                <div className="col-lg-12">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className='col-lg-6'>
                                                <label className='input-label contact_form_label' htmlFor="firstName"> First Name</label>
                                                <input
                                                    type='text'
                                                    name='firstName'
                                                    value={formData.firstName}
                                                    pattern="^\S+$"
                                                    title='FirstName should not include any space'
                                                    onChange={handleChange}
                                                    className='form-control bg-transparent form-input contact_form_input'
                                                    required
                                                />
                                            </div>
                                            <div className='col-lg-6 ps-lg-5'>
                                                <label className='input-label contact_form_label' htmlFor="lastName"> Last Name</label>
                                                <input
                                                    type='text'
                                                    name='lastName'
                                                    pattern="^\S+$"
                                                    title='LastName should not include any space'
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    className='form-control bg-transparent form-input contact_form_input'
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <label className='input-label contact_form_label' htmlFor="email"> Email</label>
                                                <input
                                                    type='email'
                                                    name='email'
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                    title='Invalid email'
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className='form-control bg-transparent form-input contact_form_input'
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <label className='input-label contact_form_label' htmlFor="message"> Message</label>
                                                <textarea
                                                    className='contact_txtarea'
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div className='row py-5'>
                                            <div className='d-flex justify-content-center'>
                                                <button type='submit' className='contact_form_btn'>Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Contact;

